import React from 'react';
import PropTypes from 'prop-types';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMAppHelper from 'components/helpers/SMAppHelper';
import update from 'react-addons-update';
import SMUserResource from 'resources/SMUserResource';

class SMUFavoriteListCreateView extends SMDashboardBaseView {

  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      listItems: this.props.listItems,
      errorText: ""
    };
  }

  updateState(state){
    this.props.updateState(state);
  }

  componentDidMount() {
    this.applyResponsive();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isOpen === true && prevProps.isOpen === false) {
      SMAppHelper.canBodyScroll(false);
      $(this.refs.modal).niftyModal({
        afterClose: (modal, e)=>{
          this.dismiss();
          e.preventDefault();
          SMAppHelper.canBodyScroll(true);
        }
      });
    }
  }

  dismiss(e) {
    $(this.refs.modal).find(".md-close").click();
    if (e) {
      e.preventDefault();
    } else {
      if(this.props.delegate && typeof this.props.delegate.favoriteListCreateViewDidClose === 'function'){
        this.props.delegate.favoriteListCreateViewDidClose();
      }
    }
  }

  formDidSubmit(e) {
    e.preventDefault();
    let favoriteListName = this.refs.favoriteListName.value;
    let responseHandler = (data, error, xhr)=>{
      if (error) {
        if (xhr.responseJSON.message) {
          this.setState({errorText: xhr.responseJSON.message,});
        } else {
          this.setState({errorText: I18n.t("dashboard.error_000001"),});
        }
      } else {
        this.setState({
          listItems: update(this.props.listItems, {$unshift: [data]})
        });
        this.updateState(this.state);
        this.dismiss();
      }
    };
    SMUserResource.postFavoriteList(this.props.user.username, favoriteListName, responseHandler);
  }

  renderFormItemError() {
    const message = this.state.errorText;
    if (message) {
      return(
        <p className="dashboad-favorite__popup-form-error"><i className="fa fa-exclamation-circle mr3"></i>{message}</p>
      );
    }
    return null;
  }

  render() {
    return (
      <div>
        <div className="md-modal md-effect-101 md-width-800" ref="modal">
          <div className="md-content">
            <div className="page__popup dashboad-favorite__input">
              <form ref="form" onSubmit={this.formDidSubmit.bind(this)}>
                <p className="page__popup__cancel dashboad-favorite__popup-cancel">
                  <a className="md-close" onClick={this.dismiss.bind(this)} href="#">
                    <span className="page__popup__cancel-icon dashboad-favorite__popup-cancel-icon">×</span>
                    <span className="dashboad-favorite__popup-cancel-text">キャンセル</span>
                  </a>
                </p>
                <div className="popup-headline">
                  <h1 className="popup-headline__title">新規リスト作成</h1>
                  <p className="dashboad-favorite__popup-headline-text">リスト名を入力してください。</p>
                </div>
                <div className="dashboad-favorite__popup-form">
                  <input ref="favoriteListName" type="text" className="popup-form__text popup-form__textarea dashboad-favorite__popup-form-area" placeholder={I18n.t('dashboard.text_000900')} />
                  {this.renderFormItemError()}
                </div>
                <input type="submit" name="commit" value="リストの作成" className="button-blue dashboad-favorite__popup-content-button" />
                <div className="dashboad-favorite__popup-add-content-error">
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="md-overlay"></div>
      </div>
    );
  }
}

SMUFavoriteListCreateView.propTypes = {
  user: PropTypes.object.isRequired
};
export default SMUFavoriteListCreateView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/SMUFavoriteListCreateView.jsx